import React from 'react';

import { useTranslation } from '../../translations/useTranslation';

interface Props {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
}

export const LoginDevInput: React.FC<Props> = ({ value, onChange, onBlur }) => {
  const { t, keys } = useTranslation();

  return (
    <div className="width-100%">
      <label htmlFor="personalIdNumber">
        <span
          id="membership-app__login-input-labelId"
          className="membership-app__login-input-text"
        >
          {t(keys.uiPersonalIdNumber)}
        </span>
        <input
          className="form-control"
          id="personalIdNumber"
          name="personalIdNumber"
          type="text"
          value={value}
          autoCorrect="off"
          pattern="[0-9]*"
          onChange={onChange}
          onBlur={onBlur}
          tabIndex={0}
          autoFocus
          aria-label="membership-app__login-input-labelId"
        />
      </label>
    </div>
  );
};
